import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core'
import {ModuleWebsiteSearchPaginator} from '../../../interfaces/module-website-search-paginator'

@Component({
  selector: 'dmmp-see-more-paginator',
  templateUrl: './see-more-paginator.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SeeMorePaginatorComponent {

  @Input() currentPage: number
  @Input() totalPages
  @Output() selectedPage: EventEmitter<number> = new EventEmitter<number>()
  @Input() module: ModuleWebsiteSearchPaginator

  nextPage() {
    this.selectedPage.emit(++this.currentPage)
  }

}
